import React from "react";
import MainMenuItem from "./MainMenuItem";
import "./MainMenu.css";

const MainMenu = ({ items }) => (
  <div className="main-manu__background">
    <ul>
      {items.map((el) => (
        <MainMenuItem label={el.label} action={el.action} key={el.label} />
      ))}
    </ul>
  </div>
);

export default MainMenu;
